var map = {
	"./Auth/Login": 887,
	"./Auth/Login.vue": 887,
	"./Dashboard/Appointments/Index": 5354,
	"./Dashboard/Appointments/Index.vue": 5354,
	"./Dashboard/Carbs/Index": 7883,
	"./Dashboard/Carbs/Index.vue": 7883,
	"./Dashboard/Foods/Index": 3047,
	"./Dashboard/Foods/Index.vue": 3047,
	"./Dashboard/Forms/Index": 4136,
	"./Dashboard/Forms/Index.vue": 4136,
	"./Dashboard/Goals/Index": 388,
	"./Dashboard/Goals/Index.vue": 388,
	"./Dashboard/Groups/Index": 7942,
	"./Dashboard/Groups/Index.vue": 7942,
	"./Dashboard/HealthTips/Index": 7654,
	"./Dashboard/HealthTips/Index.vue": 7654,
	"./Dashboard/Patients/Detail": 4391,
	"./Dashboard/Patients/Detail.vue": 4391,
	"./Dashboard/Patients/Index": 7608,
	"./Dashboard/Patients/Index.vue": 7608,
	"./Dashboard/Patients/Tabs/CarePlan": 9009,
	"./Dashboard/Patients/Tabs/CarePlan.vue": 9009,
	"./Dashboard/Patients/Tabs/Certificate": 9183,
	"./Dashboard/Patients/Tabs/Certificate.vue": 9183,
	"./Dashboard/Patients/Tabs/Chat": 3193,
	"./Dashboard/Patients/Tabs/Chat.vue": 3193,
	"./Dashboard/Patients/Tabs/DietForm": 9265,
	"./Dashboard/Patients/Tabs/DietForm.vue": 9265,
	"./Dashboard/Patients/Tabs/Evolution": 5320,
	"./Dashboard/Patients/Tabs/Evolution.vue": 5320,
	"./Dashboard/Patients/Tabs/Forms": 4816,
	"./Dashboard/Patients/Tabs/Forms.vue": 4816,
	"./Dashboard/Patients/Tabs/HealthDiary": 4322,
	"./Dashboard/Patients/Tabs/HealthDiary.vue": 4322,
	"./Dashboard/Patients/Tabs/Milestone": 4119,
	"./Dashboard/Patients/Tabs/Milestone.vue": 4119,
	"./Dashboard/Patients/Tabs/Notifications": 5113,
	"./Dashboard/Patients/Tabs/Notifications.vue": 5113,
	"./Dashboard/Patients/Tabs/OnlineConsultation": 3766,
	"./Dashboard/Patients/Tabs/OnlineConsultation.vue": 3766,
	"./Dashboard/Patients/Tabs/Prescription": 3291,
	"./Dashboard/Patients/Tabs/Prescription.vue": 3291,
	"./Dashboard/Patients/Tabs/Score": 952,
	"./Dashboard/Patients/Tabs/Score.vue": 952,
	"./Dashboard/Patients/Tabs/Timeline": 1586,
	"./Dashboard/Patients/Tabs/Timeline.vue": 1586,
	"./Dashboard/Professionals/Index": 3018,
	"./Dashboard/Professionals/Index.vue": 3018,
	"./Dashboard/Profile": 3198,
	"./Dashboard/Profile.vue": 3198,
	"./Dashboard/Specialties/Index": 3985,
	"./Dashboard/Specialties/Index.vue": 3985,
	"./Dashboard/Terms": 1714,
	"./Dashboard/Terms.vue": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;